import React from 'react'
import { Link } from 'react-router-dom'
import { Modal } from 'react-bootstrap'

const CardModal = (props) => {
    return (
        <Modal show={props.show} onHide={props.onHide}>
            <Modal.Header closeButton></Modal.Header>

            <div className="modal-body space-y-20 pd-40">
                <h3>Mua vật phẩm</h3>
                <p className="text-center">
                    <span className="price color-popup">★ Karambit | Doppler</span>
                </p>
                <div className="hr"></div>
                <div className="d-flex justify-content-between">
                    <p className="text-left price color-popup"> Minimal Wear</p>
                    <p className="text-center price color-popup"> Ruby</p>
                    <p className="text-right price color-popup"> 0.1122412</p>
                </div>
                <div className="d-flex justify-content-between">
                    <p> Giá:</p>
                    <p className="text-right price color-popup"> 100.000 vnđ</p>
                </div>
                <input type="text" className="form-control" placeholder="Link offer" />
                <Link
                    to="/login"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#popup_bid_success"
                    data-dismiss="modal"
                    aria-label="Close"
                >
                    {' '}
                    Mua
                </Link>
            </div>
        </Modal>
    )
}

export default CardModal
